import InviteeLists from "../../InviteeSection/InviteeLists";
import Reveal from "../Reveal";
import Section from "./Section";

/**
 * The family lists, shared with every theme through InviteeLists (same lists, same
 * conditions); renders nothing when none are filled.
 */
const Blessings = () => (
  <InviteeLists>
    {(lists) => (
      <Section
        className="rm-families"
        label="With blessings from our families"
        flora="spray-left"
        seed={77}
        kicker="With Love & Blessings"
        title="Our Families"
      >
        <div className="rm-families__lists">
          {lists.map(({ title, names }, i) => (
            <Reveal key={title} className="rm-family" delay={0.1 + i * 0.12}>
              <p className="rm-kicker rm-family__title">{title}</p>
              <p className="rm-family__names">{names}</p>
            </Reveal>
          ))}
        </div>
      </Section>
    )}
  </InviteeLists>
);

export default Blessings;
